module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_dg-5bd0db5c296792a3bc925c3c478fae2d.png";